import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { loginUser, logoutUser } from './actions';
import ImpersonationForm from './ImpersonationForm';
import { Redirect } from 'react-router-dom';
import { Alert } from 'react-bootstrap';
import { withTranslation, Trans } from 'react-i18next';
import queryString from 'query-string';
import ReduxBlockUi from 'react-block-ui/redux';
import { LOGIN_REQUEST, LOGIN_SUCCESS, LOGIN_FAILURE } from './actions';

class Impersonate extends React.Component {
	constructor(props) {
		super(props);
		this.handleImpersonationLogin = this.handleImpersonationLogin.bind(this);
		this.state = {
			ready: false
		};
	}

	componentDidMount() {
		this.props.logoutUser();
		this.setState({ ready: true });
	}

	handleImpersonationLogin(credentials) {
		const { impersonatedUsername, loginUser } = this.props;
		if (impersonatedUsername) {
			loginUser({ ...credentials, impersonatedUsername });
		}
	}

	render() {
		if (this.state.ready && this.props.isAuthenticated) {
			const { from } = this.props.location.state || { from: { pathname: '/' } };
			return <Redirect to={from} />;
		}

		const { t, impersonatedUsername, originalUsername } = this.props;

		return (
			<div className='franchise-portal'>
				<ReduxBlockUi block={LOGIN_REQUEST} unblock={[LOGIN_SUCCESS, LOGIN_FAILURE]}>
					<div className='box-login'>
						{impersonatedUsername && <Alert bsStyle='warning'>
							<Trans i18nKey='FO_Impersonate_Warning'>
								Logging in on behalf of <b style={{ color: '#1d93d1' }}>{{ impersonatedUsername }}</b>
							</Trans>
						</Alert>}
						<p>{t('FO_Impersonate_Text')}</p>
						<ImpersonationForm onSubmit={this.handleImpersonationLogin} initialValues={{ username: originalUsername }} />
					</div>
				</ReduxBlockUi>
			</div>
		);
	}
}

Impersonate.propTypes = {
	loginUser: PropTypes.func,
};

const mapStateToProps = (state, ownProps) => {
	const { i, o } = queryString.parse(ownProps.location.search);

	return {
		impersonatedUsername: i,
		originalUsername: o,
		isAuthenticated: state.auth.isAuthenticated
	};
}

export default connect(mapStateToProps, {
	loginUser,
	logoutUser
})(withTranslation()(Impersonate));